export default __webpack_public_path__ + "static/media/1-7t.86013746.png";